import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";
import WarehouseMap from "../../../classes/WarehouseMap";

export default {
  routes: [
    {
      name: "admin-warehouse-barcodes",
      path: "warehouse-barcodes/:warehouses*",
      component: () => import("pages/admin/WarehouseBarcodes"),
      meta: {
        // Same bar as the Warehouse Maps pages the labels are printed from.
        auth: () => WarehouseMap.canBeViewedBy(store.state.main.user),
        title: i18n.global.t("warehouse.warehouseBarcodes"),
        icon: "barcode",
        color: "admin",
      },
    },
  ],
};
